// import { useState, useEffect } from 'react';
// import { ProfileFormHeader } from '../ProfileFormHeader';
// import HalfRow from '../../../../components/formElements/HalfRow';
// import FormInputField from '../../../../components/formElements/FormInputField';
// import FullRow from '../../../../components/formElements/FullRow';
// import useUserDetails from './hooks/useUserDetails';
// import CustomRedAlert from '../../../../components/alerts/customRedAlert/CustomRedAlert';
// import CustomSuccessModal from '../../../../components/alerts/customSuccessModal/CustomSuccessModal';
// import { CalendarIcon, PhoneIcon, UsersIcon, EnvelopeIcon } from '@heroicons/react/24/outline';
// import FormSelectDrop from '../../../../components/formElements/FormSelectDrop';
// import PhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/style.css';
// import { Controller } from 'react-hook-form';

// export default function UserDetails(props) {
//     const { selectedUser, onCancel, selectionMode, onSuccessfulSave, userStatusCatalog, documentTypes } = props;

//     const [openReturnAlert, setOpenReturnAlert] = useState(false);
//     const formattedGenderData = [
//         { id: 'male', label: 'masculino', value: 'masculino' },
//         { id: 'female', label: 'femenina', value: 'femenina' },
//         { id: 'other', label: 'otra', value: 'otra' }
//     ];
//     const formattedBloodData = [
//         { id: 'A+', label: 'A+', value: 'A+' },
//         { id: 'A', label: 'A', value: 'A' },
//         { id: 'B+', label: 'B+', value: 'B+' },
//         { id: 'O+', label: 'O+', value: 'O+' },
//         { id: 'O-', label: 'O-', value: 'O-' },
//         { id: 'AB+', label: 'AB+', value: 'AB+' },
//         { id: 'AB-', label: 'AB-', value: 'AB-' },
//         { id: 'B+', label: 'B+', value: 'B+' }
//     ];

//     const {
//         handleSubmit,
//         register,
//         errors,
//         isDirty,
//         closeErrorMessage,
//         onCloseSuccessMessage,
//         showSuccessModal,
//         showErrorModal,
//         errorBody,
//         successBody,
//         onSaveSubmit,
//         documentTypesOptions,
//         userStatusOptions,
//         watch,
//         setValue,
//         getValues,
//         control
//     } = useUserDetails(selectedUser, onSuccessfulSave, selectionMode, userStatusCatalog, documentTypes);

//     const phoneValue = watch('phone');

//     useEffect(() => {
//         register('phone', {
//             required: 'Este campo es requerido',
//             minLength: {
//                 value: 8,
//                 message: 'Debe contener al menos 8 dígitos'
//             },
//             validate: (value) => /^[0-9]+$/.test(value.replace(/\+/g, '')) || 'Solo se permiten números'
//         });
//     }, [register]);

//     if (!selectionMode) {
//         return null;
//     }

//     const _onReturnToUsers = () => {
//         if (isDirty) {
//             setOpenReturnAlert(true);
//         } else {
//             onCancel();
//         }
//     };

//     const _onConfirmCancelAppointment = () => {
//         setOpenReturnAlert(false);
//         onCancel();
//     };

//     const _onCancelConfirmationForClosing = () => {
//         setOpenReturnAlert(false);
//     };

//     return (
//         <form onSubmit={handleSubmit(onSaveSubmit)}>
//             <div className="shadow sm:rounded-md sm:overflow-hidden">
//                 <div className="bg-white py-6 px-4 space-y-6 sm:p-6">
//                     {selectionMode !== 'viewOnly' && <ProfileFormHeader title={'Editar datos de paciente'} />}
//                     <div>
//                         <h3 className="text-lg leading-6 font-medium text-dl-secondary">Detalles del paciente</h3>
//                     </div>
//                     <div className="grid grid-cols-6 gap-6">
//                         <HalfRow>
//                             <FormInputField
//                                 identifier="firstName"
//                                 label="Nombre del Paciente"
//                                 iconComponent={<UsersIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />}
//                                 type="text"
//                                 registration={register('firstName', {
//                                     required: 'Este campo es requerido',
//                                     validate: (value) => {
//                                         if (!value.trim()) {
//                                             return 'No se permiten solo espacios';
//                                         }
//                                         return true;
//                                     },
//                                     minLength: {
//                                         value: 2,
//                                         message: 'Debe tener al menos 2 caracteres'
//                                     },
//                                     pattern: {
//                                         value: /^[A-Za-zÁÉÍÓÚÑáéíóúñ\s',-]+$/,
//                                         message: 'Solo se permiten letras y espacios'
//                                     }
//                                 })}
//                                 errorMessage={errors.firstName?.message}
//                                 disabled={selectionMode === 'viewOnly'}
//                             />
//                         </HalfRow>

//                         <HalfRow>
//                             <FormInputField
//                                 identifier="lastName"
//                                 label="Apellido del Paciente"
//                                 iconComponent={<UsersIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />}
//                                 type="text"
//                                 registration={register('lastName', {
//                                     required: 'Este campo es requerido',
//                                     validate: (value) => {
//                                         if (!value.trim()) {
//                                             return 'No se permiten solo espacios';
//                                         }
//                                         return true;
//                                     },
//                                     minLength: {
//                                         value: 2,
//                                         message: 'Debe tener al menos 2 caracteres'
//                                     },
//                                     pattern: {
//                                         value: /^[A-Za-zÁÉÍÓÚÑáéíóúñ\s',-]+$/,
//                                         message: 'Solo se permiten letras y espacios'
//                                     }
//                                 })}
//                                 errorMessage={errors.lastName?.message}
//                                 disabled={selectionMode === 'viewOnly'}
//                             />
//                         </HalfRow>

//                         <HalfRow>
//                             <FormInputField
//                                 identifier="birthDate"
//                                 label="Fecha de cumpleaños"
//                                 iconComponent={<CalendarIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />}
//                                 type="string"
//                                 registration={register('birthDate', { required: 'Este campo es requerido' })}
//                                 errorMessage={errors.birthDate?.message}
//                                 disabled
//                             />
//                         </HalfRow>
//                         <HalfRow>
//                             <label className="block text-sm font-medium text-gray-700 mb-1">
//                                 Número de teléfono de contacto
//                             </label>
//                             <Controller
//                                 name="fullPhone"
//                                 control={control}
//                                 rules={{ required: 'Teléfono es obligatorio' }}
//                                 render={({ field: { onChange, value, ref } }) => {
//                                     const mergedValue =
//                                         value || `${getValues('countryCode') || ''}${getValues('phone') || ''}`;

//                                     return (
//                                         <PhoneInput
//                                             value={mergedValue}
//                                             onChange={(val, country) => {
//                                                 const codeVal = `+${country.dialCode}`;
//                                                 const phoneVal = val.replace(country.dialCode, '').replace(/^\+/, '');

//                                                 setValue('countryCode', codeVal);
//                                                 setValue('phone', phoneVal);

//                                                 onChange(val);
//                                             }}
//                                             enableSearch
//                                             disableDropdown={false}
//                                             disableCountryCode={false}
//                                             disableAreaCodes={true}
//                                             countryCodeEditable={false}
//                                             placeholder="Ingrese su número"
//                                             inputProps={{
//                                                 name: 'phone',
//                                                 required: true,
//                                                 autoFocus: false,
//                                                 disabled: selectionMode === 'viewOnly',
//                                                 ref,
//                                             }}
//                                             inputClass={`form-input block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm
//             ${errors.phone ? 'border-red-500' : ''}`}
//                                             containerClass="w-full"
//                                         />
//                                     );
//                                 }}
//                             />
//                             {(errors.phone || errors.fullPhone) && (
//                                 <p className="mt-1 text-sm text-red-600">
//                                     {errors.fullPhone?.message || errors.phone?.message}
//                                 </p>
//                             )}
//                         </HalfRow>

//                         {/* here email address */}
//                         <HalfRow>
//                             <FormInputField
//                                 identifier="address"
//                                 label="Dirección de residencia"
//                                 iconComponent={<UsersIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />}
//                                 type="string"
//                                 registration={register('address', { required: 'Este campo es requerido' })}
//                                 errorMessage={errors.address?.message}
//                                 disabled={selectionMode === 'viewOnly'}
//                             />
//                         </HalfRow>
//                         <HalfRow>
//                             <FormInputField
//                                 identifier="height"
//                                 label="Estatura"
//                                 type="string"
//                                 placeholder="height in CM"
//                                 registration={register('height', {
//                                     onChange: (e) => {
//                                         const value = e.target.value;
//                                         if (!/^(?!0\d)\d*(\.\d+)?$/.test(value)) {
//                                             e.target.value = value.replace(/[^0-9.]/g, '');
//                                         }
//                                     }
//                                 })}
//                                 errorMessage={errors.height?.message}
//                                 disabled
//                             />
//                         </HalfRow>
//                         <FullRow>
//                             <FormInputField
//                                 identifier="email"
//                                 label="Dirección de email"
//                                 iconComponent={<EnvelopeIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />}
//                                 type="string"
//                                 registration={register('email', { required: 'Este campo es requerido' })}
//                                 errorMessage={errors.email?.message}
//                                 disabled
//                             />
//                         </FullRow>
//                         <FullRow>
//                             {/* gender in spanish */}
//                             <FormSelectDrop
//                                 identifier="gender"
//                                 label="Sexo"
//                                 registration={register('gender')}
//                                 options={formattedGenderData}
//                                 errorMessage={errors.gender?.message}
//                                 disabled
//                             />
//                         </FullRow>
//                         <FullRow>
//                             <FormSelectDrop
//                                 identifier="blood_type"
//                                 label="Tipo de sangre"
//                                 registration={register('blood_type')}
//                                 options={formattedBloodData}
//                                 errorMessage={errors.blood_type?.message}
//                                 disabled
//                             />
//                         </FullRow>
//                         <HalfRow>
//                             <FormSelectDrop
//                                 label={'Tipo de Documento'}
//                                 identifier={'idDocumentTypes'}
//                                 options={documentTypesOptions}
//                                 defaultValue={selectedUser.idDocumentTypes}
//                                 defaultOption={false}
//                                 helperText={'Requerido'}
//                                 registration={register('idDocumentTypes', { required: 'Este campo es requerido' })}
//                                 errorMessage={errors.idDocumentTypes?.message}
//                                 disabled
//                             />
//                         </HalfRow>
//                         <HalfRow>
//                             <FormInputField
//                                 identifier="personalDocument"
//                                 label="Número de documento"
//                                 type="string"
//                                 registration={register('personalDocument', { required: 'Este campo es requerido' })}
//                                 errorMessage={errors.personalDocument?.message}
//                                 disabled
//                             />
//                         </HalfRow>
//                         <HalfRow>
//                             <FormInputField
//                                 identifier="creation"
//                                 label="Creación"
//                                 type="string"
//                                 registration={register('creation', { required: 'Este campo es requerido' })}
//                                 errorMessage={errors.creation?.message}
//                                 disabled
//                             />
//                         </HalfRow>
//                         <HalfRow>
//                             <FormSelectDrop
//                                 label={'Estado del usuario'}
//                                 identifier={'idUserStatus'}
//                                 options={userStatusOptions}
//                                 defaultValue={selectedUser.idUserStatus}
//                                 defaultOption={false}
//                                 helperText={'Requerido'}
//                                 registration={register('idUserStatus', { required: 'Este campo es requerido' })}
//                                 errorMessage={errors.idUserStatus?.message}
//                             />
//                         </HalfRow>
//                     </div>
//                 </div>
//                 <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
//                     {/*<button
//                           type="button"
//                           onClick={onCancel}
//                           className="bg-dl-red border border-transparent rounded-full shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-dl-primary-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-dl-red"
//                       >
//                           Cerrar
//                       </button>*/}
//                     <button
//                         type="button"
//                         onClick={_onReturnToUsers}
//                         className="mr-2 rounded-full border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-dl-accent focus:ring-offset-2"
//                     >
//                         Regresar
//                     </button>
//                     {selectionMode === 'edit' && (
//                         <button
//                             type="submit"
//                             disabled={!isDirty}
//                             className="disabled:bg-dl-primary-700 bg-dl-primary-900 border border-transparent rounded-full shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-dl-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-dl-primary-700"
//                         >
//                             Actualizar Datos
//                         </button>
//                     )}
//                 </div>
//             </div>

//             {openReturnAlert && (
//                 <CustomRedAlert
//                     open={openReturnAlert}
//                     title={'¿Desea descartar los cambios?'}
//                     bodyText={'La cita ha sido modificada, por favor confirme que desea salir de esta vista.'}
//                     onClose={_onCancelConfirmationForClosing}
//                     mainActionText={'Salir'}
//                     onMainAction={_onConfirmCancelAppointment}
//                     secondaryActionText={'Cancelar'}
//                     onSecondaryAction={_onCancelConfirmationForClosing}
//                 />
//             )}

//             {showErrorModal && (
//                 <CustomRedAlert
//                     open={showErrorModal}
//                     title={'Ocurrió un error.'}
//                     bodyText={errorBody}
//                     onClose={closeErrorMessage}
//                 />
//             )}

//             {showSuccessModal && (
//                 <CustomSuccessModal
//                     title={'Registro actualizado con éxito'}
//                     bodyText={successBody}
//                     buttonText={'Aceptar'}
//                     buttonAction={onCloseSuccessMessage}
//                     open={showSuccessModal}
//                     onClose={onCloseSuccessMessage}
//                 />
//             )}
//         </form>
//     );
// }




import { useState, useEffect } from 'react';
import { ProfileFormHeader } from '../ProfileFormHeader';
import HalfRow from '../../../../components/formElements/HalfRow';
import FormInputField from '../../../../components/formElements/FormInputField';
import FullRow from '../../../../components/formElements/FullRow';
import useUserDetails from './hooks/useUserDetails';
import CustomRedAlert from '../../../../components/alerts/customRedAlert/CustomRedAlert';
import CustomSuccessModal from '../../../../components/alerts/customSuccessModal/CustomSuccessModal';
import { CalendarIcon, PhoneIcon, UsersIcon, EnvelopeIcon } from '@heroicons/react/24/outline';
import FormSelectDrop from '../../../../components/formElements/FormSelectDrop';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { Controller } from 'react-hook-form';

export default function UserDetails(props) {
    const { selectedUser, onCancel, selectionMode, onSuccessfulSave, userStatusCatalog, documentTypes } = props;

    const [openReturnAlert, setOpenReturnAlert] = useState(false);

    const formattedGenderData = [
        { id: 'male', label: 'masculino', value: 'masculino' },
        { id: 'female', label: 'femenina', value: 'femenina' },
        { id: 'other', label: 'otra', value: 'otra' }
    ];

    const formattedBloodData = [
        { id: 'A+', label: 'A+', value: 'A+' },
        { id: 'A', label: 'A', value: 'A' },
        { id: 'B+', label: 'B+', value: 'B+' },
        { id: 'O+', label: 'O+', value: 'O+' },
        { id: 'O-', label: 'O-', value: 'O-' },
        { id: 'AB+', label: 'AB+', value: 'AB+' },
        { id: 'AB-', label: 'AB-', value: 'AB-' },
        { id: 'B+', label: 'B+', value: 'B+' }
    ];

    const {
        handleSubmit,
        register,
        errors,
        isDirty,
        closeErrorMessage,
        onCloseSuccessMessage,
        showSuccessModal,
        showErrorModal,
        errorBody,
        successBody,
        onSaveSubmit,
        documentTypesOptions,
        userStatusOptions,
        watch,
        setValue,
        getValues,
        control
    } = useUserDetails(selectedUser, onSuccessfulSave, selectionMode, userStatusCatalog, documentTypes);

    const phoneValue = watch('phone');
    const countryCodeValue = watch('countryCode');

    // Phone field ko properly initialize karein jab selectedUser change ho
    useEffect(() => {
        if (selectedUser) {
            // Phone aur countryCode ko form state mein set karein
            if (selectedUser.phone) {
                setValue('phone', selectedUser.phone, { shouldValidate: false });
            }
            if (selectedUser.countryCode) {
                setValue('countryCode', selectedUser.countryCode, { shouldValidate: false });
            }
            // fullPhone ko bhi set karein agar available hai
            if (selectedUser.fullPhone) {
                setValue('fullPhone', selectedUser.fullPhone, { shouldValidate: false });
            } else if (selectedUser.countryCode && selectedUser.phone) {
                // Agar fullPhone nahi hai, to countryCode + phone se banao
                const cleanCode = (selectedUser.countryCode || '').replace(/^\+/, '');
                const fullPhone = `${cleanCode}${selectedUser.phone || ''}`;
                setValue('fullPhone', fullPhone, { shouldValidate: false });
            }
        }
    }, [selectedUser, setValue]);

    // Phone field registration - improved validation
    useEffect(() => {
        register('phone', {
            required: false, // fullPhone se validate karenge
            minLength: {
                value: 8,
                message: 'Debe contener al menos 8 dígitos'
            },
            validate: (value) => {
                // Agar phone empty hai, to fullPhone check karein
                if (!value || value.trim() === '') {
                    const fullPhone = getValues('fullPhone');
                    if (fullPhone && fullPhone.trim() !== '' && fullPhone.replace(/\D/g, '').length >= 8) {
                        return true; // fullPhone valid hai to phone required nahi
                    }
                    // Agar fullPhone bhi empty hai, to error
                    return 'Este campo es requerido';
                }
                // Phone number validation
                const digits = value.replace(/\D/g, '');
                if (digits.length < 8) {
                    return 'Debe contener al menos 8 dígitos';
                }
                return /^[0-9]+$/.test(value.replace(/\+/g, '')) || 'Solo se permiten números';
            }
        });
    }, [register, getValues]);

    if (!selectionMode) {
        return null;
    }

    const _onReturnToUsers = () => {
        if (isDirty) {
            setOpenReturnAlert(true);
        } else {
            onCancel();
        }
    };

    const _onConfirmCancelAppointment = () => {
        setOpenReturnAlert(false);
        onCancel();
    };

    const _onCancelConfirmationForClosing = () => {
        setOpenReturnAlert(false);
    };

    return (
        <form onSubmit={handleSubmit(onSaveSubmit)}>
            <div className="shadow sm:rounded-md sm:overflow-hidden">
                <div className="bg-white py-6 px-4 space-y-6 sm:p-6">
                    {selectionMode !== 'viewOnly' && <ProfileFormHeader title={'Editar datos de paciente'} />}

                    <div>
                        <h3 className="text-lg leading-6 font-medium text-dl-secondary">Detalles del paciente</h3>
                    </div>

                    <div className="grid grid-cols-6 gap-6">
                        <HalfRow>
                            <FormInputField
                                identifier="firstName"
                                label="Nombre del Paciente"
                                iconComponent={<UsersIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />}
                                type="text"
                                registration={register('firstName', {
                                    required: 'Este campo es requerido',
                                    validate: (value) => {
                                        if (!value.trim()) {
                                            return 'No se permiten solo espacios';
                                        }
                                        return true;
                                    },
                                    minLength: {
                                        value: 2,
                                        message: 'Debe tener al menos 2 caracteres'
                                    },
                                    pattern: {
                                        value: /^[A-Za-zÁÉÍÓÚÑáéíóúñ\s',-]+$/,
                                        message: 'Solo se permiten letras y espacios'
                                    }
                                })}
                                errorMessage={errors.firstName?.message}
                                disabled={selectionMode === 'viewOnly'}
                            />
                        </HalfRow>

                        <HalfRow>
                            <FormInputField
                                identifier="lastName"
                                label="Apellido del Paciente"
                                iconComponent={<UsersIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />}
                                type="text"
                                registration={register('lastName', {
                                    required: 'Este campo es requerido',
                                    validate: (value) => {
                                        if (!value.trim()) {
                                            return 'No se permiten solo espacios';
                                        }
                                        return true;
                                    },
                                    minLength: {
                                        value: 2,
                                        message: 'Debe tener al menos 2 caracteres'
                                    },
                                    pattern: {
                                        value: /^[A-Za-zÁÉÍÓÚÑáéíóúñ\s',-]+$/,
                                        message: 'Solo se permiten letras y espacios'
                                    }
                                })}
                                errorMessage={errors.lastName?.message}
                                disabled={selectionMode === 'viewOnly'}
                            />
                        </HalfRow>

                        <HalfRow>
                            <FormInputField
                                identifier="birthDate"
                                label="Fecha de cumpleaños"
                                iconComponent={<CalendarIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />}
                                type="string"
                                registration={register('birthDate', { required: 'Este campo es requerido' })}
                                errorMessage={errors.birthDate?.message}
                                disabled
                            />
                        </HalfRow>

                        <HalfRow>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Número de teléfono de contacto
                            </label>
                            <Controller
                                name="fullPhone"
                                control={control}
                                rules={{
                                    validate: (value) => {
                                        // Pehle form state se check karein
                                        let phoneValue = value;
                                        
                                        // Agar fullPhone empty hai, to phone aur countryCode se banao
                                        if (!phoneValue || phoneValue.trim() === '') {
                                            const phone = getValues('phone');
                                            const countryCode = getValues('countryCode');
                                            
                                            if (countryCode && phone) {
                                                const cleanCode = countryCode.replace(/^\+/, '');
                                                phoneValue = `${cleanCode}${phone}`;
                                            } else if (selectedUser) {
                                                // Agar form state me nahi hai, to selectedUser se lo
                                                if (selectedUser.fullPhone) {
                                                    phoneValue = selectedUser.fullPhone;
                                                } else if (selectedUser.countryCode && selectedUser.phone) {
                                                    const cleanCode = (selectedUser.countryCode || '').replace(/^\+/, '');
                                                    phoneValue = `${cleanCode}${selectedUser.phone || ''}`;
                                                } else if (selectedUser.phone) {
                                                    // Agar sirf phone hai without countryCode
                                                    phoneValue = selectedUser.phone;
                                                }
                                            }
                                        }
                                        
                                        // Final validation - agar selectedUser me phone hai to allow
                                        if (!phoneValue || phoneValue.trim() === '') {
                                            // Check if selectedUser has phone number
                                            if (selectedUser && (selectedUser.phone || selectedUser.fullPhone)) {
                                                return true; // Allow if phone exists in selectedUser
                                            }
                                            return 'Teléfono es obligatorio';
                                        }
                                        
                                        // fullPhone validation
                                        const digits = phoneValue.replace(/\D/g, '');
                                        if (digits.length < 8) {
                                            return 'Número de teléfono inválido (mínimo 8 dígitos)';
                                        }
                                        return true;
                                    }
                                }}
                                render={({ field: { onChange, value, ref } }) => {
                                    // Pehle selectedUser se value lo, phir form state se
                                    let mergedValue = value;

                                    if (!mergedValue && selectedUser) {
                                        // Agar form state mein nahi hai, to selectedUser se lo
                                        if (selectedUser.fullPhone) {
                                            mergedValue = selectedUser.fullPhone;
                                        } else if (selectedUser.countryCode && selectedUser.phone) {
                                            const cleanCode = (selectedUser.countryCode || '').replace(/^\+/, '');
                                            mergedValue = `${cleanCode}${selectedUser.phone || ''}`;
                                        }
                                    }

                                    // Agar abhi bhi nahi hai, to form state se try karein
                                    if (!mergedValue) {
                                        const formCountryCode = getValues('countryCode') || '';
                                        const formPhone = getValues('phone') || '';
                                        if (formCountryCode || formPhone) {
                                            const cleanCode = formCountryCode.replace(/^\+/, '');
                                            mergedValue = `${cleanCode}${formPhone}`;
                                        }
                                    }

                                    return (
                                        <PhoneInput
                                            value={mergedValue || ''}
                                            onChange={(val, country) => {
                                                const codeVal = `+${country.dialCode}`;
                                                const phoneVal = val.replace(country.dialCode, '').replace(/^\+/, '');

                                                setValue('countryCode', codeVal, { shouldValidate: true });
                                                setValue('phone', phoneVal, { shouldValidate: true });
                                                onChange(val);
                                                setValue('fullPhone', val, { shouldValidate: true });
                                            }}
                                            enableSearch
                                            disableDropdown={false}
                                            disableCountryCode={false}
                                            disableAreaCodes={true}
                                            countryCodeEditable={false}
                                            placeholder="Ingrese su número"
                                            inputProps={{
                                                name: 'phone',
                                                required: true,
                                                autoFocus: false,
                                                disabled: selectionMode === 'viewOnly',
                                                ref
                                            }}
                                            inputClass={`form-input block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm
                                            ${errors.phone || errors.fullPhone ? 'border-red-500' : ''}`}
                                            containerClass="w-full"
                                        />
                                    );
                                }}
                            />
                            {(errors.phone || errors.fullPhone) && (
                                <p className="mt-1 text-sm text-red-600">
                                    {errors.fullPhone?.message || errors.phone?.message}
                                </p>
                            )}
                        </HalfRow>

                        {/* here email address */}
                        <HalfRow>
                            <FormInputField
                                identifier="address"
                                label="Dirección de residencia"
                                iconComponent={<UsersIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />}
                                type="string"
                                registration={register('address', { required: 'Este campo es requerido' })}
                                errorMessage={errors.address?.message}
                                disabled={selectionMode === 'viewOnly'}
                            />
                        </HalfRow>

                        <HalfRow>
                            <FormInputField
                                identifier="height"
                                label="Estatura"
                                type="string"
                                placeholder="height in CM"
                                registration={register('height', {
                                    onChange: (e) => {
                                        const value = e.target.value;
                                        if (!/^(?!0\d)\d*(\.\d+)?$/.test(value)) {
                                            e.target.value = value.replace(/[^0-9.]/g, '');
                                        }
                                    }
                                })}
                                errorMessage={errors.height?.message}
                                disabled
                            />
                        </HalfRow>

                        <FullRow>
                            <FormInputField
                                identifier="email"
                                label="Dirección de email"
                                iconComponent={<EnvelopeIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />}
                                type="string"
                                registration={register('email', { required: 'Este campo es requerido' })}
                                errorMessage={errors.email?.message}
                                disabled
                            />
                        </FullRow>

                        <FullRow>
                            {/* gender in spanish */}
                            <FormSelectDrop
                                identifier="gender"
                                label="Sexo"
                                registration={register('gender')}
                                options={formattedGenderData}
                                errorMessage={errors.gender?.message}
                                disabled
                            />
                        </FullRow>

                        <FullRow>
                            <FormSelectDrop
                                identifier="blood_type"
                                label="Tipo de sangre"
                                registration={register('blood_type')}
                                options={formattedBloodData}
                                errorMessage={errors.blood_type?.message}
                                disabled
                            />
                        </FullRow>

                        <HalfRow>
                            <FormSelectDrop
                                label={'Tipo de Documento'}
                                identifier={'idDocumentTypes'}
                                options={documentTypesOptions}
                                defaultValue={selectedUser.idDocumentTypes}
                                defaultOption={false}
                                helperText={'Requerido'}
                                registration={register('idDocumentTypes', { required: 'Este campo es requerido' })}
                                errorMessage={errors.idDocumentTypes?.message}
                                disabled
                            />
                        </HalfRow>

                        <HalfRow>
                            <FormInputField
                                identifier="personalDocument"
                                label="Número de documento"
                                type="string"
                                registration={register('personalDocument', { required: 'Este campo es requerido' })}
                                errorMessage={errors.personalDocument?.message}
                                disabled
                            />
                        </HalfRow>

                        <HalfRow>
                            <FormInputField
                                identifier="creation"
                                label="Creación"
                                type="string"
                                registration={register('creation', { required: 'Este campo es requerido' })}
                                errorMessage={errors.creation?.message}
                                disabled
                            />
                        </HalfRow>

                        <HalfRow>
                            <FormSelectDrop
                                label={'Estado del usuario'}
                                identifier={'idUserStatus'}
                                options={userStatusOptions}
                                defaultValue={selectedUser.idUserStatus}
                                defaultOption={false}
                                helperText={'Requerido'}
                                registration={register('idUserStatus', { required: 'Este campo es requerido' })}
                                errorMessage={errors.idUserStatus?.message}
                            />
                        </HalfRow>
                    </div>
                </div>

                <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                    <button
                        type="button"
                        onClick={_onReturnToUsers}
                        className="mr-2 rounded-full border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-dl-accent focus:ring-offset-2"
                    >
                        Regresar
                    </button>

                    {selectionMode === 'edit' && (
                        <button
                            type="submit"
                            disabled={!isDirty}
                            className="disabled:bg-dl-primary-700 bg-dl-primary-900 border border-transparent rounded-full shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-dl-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-dl-primary-700"
                        >
                            Actualizar Datos
                        </button>
                    )}
                </div>
            </div>

            {openReturnAlert && (
                <CustomRedAlert
                    open={openReturnAlert}
                    title={'¿Desea descartar los cambios?'}
                    bodyText={'La cita ha sido modificada, por favor confirme que desea salir de esta vista.'}
                    onClose={_onCancelConfirmationForClosing}
                    mainActionText={'Salir'}
                    onMainAction={_onConfirmCancelAppointment}
                    secondaryActionText={'Cancelar'}
                    onSecondaryAction={_onCancelConfirmationForClosing}
                />
            )}

            {showErrorModal && (
                <CustomRedAlert
                    open={showErrorModal}
                    title={'Ocurrió un error.'}
                    bodyText={errorBody}
                    onClose={closeErrorMessage}
                />
            )}

            {showSuccessModal && (
                <CustomSuccessModal
                    title={'Registro actualizado con éxito'}
                    bodyText={successBody}
                    buttonText={'Aceptar'}
                    buttonAction={onCloseSuccessMessage}
                    open={showSuccessModal}
                    onClose={onCloseSuccessMessage}
                />
            )}
        </form>
    );
}